export function DevBanner() {
  if (import.meta.env.VITE_APP_ENV !== "dev") {
    return null;
  }

  return (
    <div className="card p-4 border-accent/50 bg-accent/10 text-center rounded-none">
      <p className="text-text-primary font-semibold text-sm">
        This is a restricted dev environment.
      </p>
      <p className="text-text-muted text-xs mt-1">
        Looking for Sendstats?{" "}
        <a href="https://sendstats.app" className="text-accent underline">
          Use sendstats.app instead
        </a>
        .
      </p>
    </div>
  );
}
